<template>
  <tbody>
    <tr 
      v-for="(row, i) in items" 
      :key="i"
    >
      <td>
        <v-text-field 
          v-if="row.editable" 
          depressed 
          v-model="row.prolistsPhrase"
        ></v-text-field>
        <template v-else>
          {{ row.prolistsPhrase}}
        </template>
      </td>

      <td>
        <v-text-field 
          v-if="row.editable" 
          depressed 
          v-model="row.myPhrase"
        ></v-text-field>
        <template v-else>
          {{ row.myPhrase}}
        </template>
      </td>

      <td class="text-right">
        <v-text-field 
          v-if="row.editable" 
          depressed 
          v-model="row.art"
        ></v-text-field>
        <template v-else>
          {{ row.art}}
        </template>
      </td>

      <!-- Buttons -->
      <!-- Edit/Save -->
      <td>
        <BaseIcon 
          v-if="!row.editable" 
          @click="edit(row)"
          icon="edit"
        />
        <BaseIcon 
          v-else 
          @click="save(row)"
          icon="save"
        />
      </td>

      <!-- Delete/Close -->
      <td>
        <BaseIcon 
          v-if="!row.editable" 
          @click="deleteRow(row)"
          icon="delete"
        />
        <BaseIcon 
          v-else 
          @click="close(row)"
          icon="close"
        />
      </td>
    </tr>
  </tbody>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
  name: "MyMappingEditRow",
  components: {
    BaseIcon
  },
  props: {
    items: {
      required: true,
      type: Array,
      default: []
    }
  },
  methods: {
    save(row) {
      this.$store.dispatch('saveMyMappingRow', row)
    },
    close(row) {
      if(row.id > 0){
        this.$store.commit('replaceNewMyMappingValuesWithOld', row)
        this.$store.commit('deleteMyMappingTempRow', row)
      } else {
        this.$store.commit('deleteMyMappingRow', row)
      }

      row.editable = false;
    },
    deleteRow(row) {
      this.$store.commit("setSelectedMyMapping", [row.id])
      this.$store.commit("setShowDeletionDialogMyMapping", true)
      // this.$store.dispatch('deleteMappingRow', row)
    },
    edit(row) {
      row.editable = true;
      this.$store.commit('setMyMappingTempRow', row)
    }
  }
}
</script>

<style>
</style>